module.exports = __webpack_public_path__ + "img/facebook.3469fa8c.png";